<template>
  <div class="container-fluid" style="background: #1B2736" id="index">
    <div class="d-flex flex-wrap">
      <div class="d-flex card m-1 flex-fill" v-for="quickLink in quickLinks" v-if="quickLink.has_permission" :key="quickLink.name">
        <div class="d-flex align-items-center justify-content-center card-body p-1 front-page-link">
          <router-link :to="{ name: quickLink.path }" class="text-center">
           {{ quickLink.name }}<i :class=quickLink.icon></i>
          </router-link>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="dashboardData !== null">
        <title-bar v-bind:title="'Membership Overview'" v-bind:description="''"/>
        <transition name="fade">
          <div>
            <membership-overview-dashboard v-if="organizationData !== null" v-bind:members="memberData" />
          </div>
        </transition>
        <title-bar v-bind:title="'Latest Members'" v-bind:description="'Members who have joined or renewed in the last 2 weeks.'" v-bind:showVisibility='true' @visibilitySwitch="toggleNewestMemberVisibility"/>
        <transition name="fade">
          <latest-members v-if="organizationData !== null && showNewestMembers" v-bind:members="memberData" />
        </transition>
        <title-bar v-bind:title="'Event Attendance Overview'" v-bind:description="'Numbers are since July 1st, 2020.'"/>
        <event-dashboard v-bind:events-data="eventsData"/>
        <title-bar v-bind:title="'Social Media Trends'" v-bind:description="'Last month\'s change and twelve month totals. Current counts will not be up-to-the-second accurate.'"/>
        <social-media-dashboard v-bind:social-statistics="socialStatistics"/>
    
        <!-- Initiatives Section, in progress -->
        <!-- <title-bar v-if="false" v-bind:title="'Initiatives Overview'" v-bind:description="''"/> -->
        <initiative-dashboard v-if="false" v-bind:initiatives="initiativesData"></initiative-dashboard>
        <!-- End Initiatives Section, in progress -->

        <title-bar v-bind:title="'Membership Data Validity'" v-bind:description="'Ensure our database has the best possible data'"/>
        <transition name="fade">
          <membership-data-validity-dashboard v-if="organizationData !== null" v-bind:members="memberData" />
        </transition>
        <title-bar id="member-audit" v-bind:title="'Audit of Membership Data'" v-bind:description="''"/>
        <audit-index></audit-index>

        <title-bar2 v-bind:title="'Activities Overview'" v-bind:description="'Numbers are since July 1st, 2021.'" v-bind:showVisibility='true' @visibilitySwitch="toggleActivityVisibility"/>
        <transition name="fade">
          <activities-dashboard v-if="organizationData !== null && showActivites" v-bind:activities="activitiesData"/>
        </transition>

        <title-bar2 id="member-list" v-bind:title="'Member List'" v-bind:description="''" v-bind:showVisibility='true' @visibilitySwitch="toggleAllMemberVisibility"/>
        <transition name="fade">
          <membership-list-dashboard v-if="organizationData !== null && showAllMembers" v-bind:members="memberData"/>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import MembershipDataValidityDashboard from './membership/dataValidity/MembershipDataValidityDashboard'
import API from '../api/index'
import SocialMediaDashboard from './homePage/SocialMediaDashboard'
import TitleBar from './homePage/TitleBar'
import TitleBar2 from './homePage/TitleBar2.vue'
import MembershipOverviewDashboard from './membership/MembershipOverviewDashboard'
import ActivitiesDashboard from './homePage/ActivitiesDashboard'
import MembershipListDashboard from './membership/MembershipListDashboard'
import OrganizationAPI from '../api/organizations'
import EventDashboard from './events/EventDashboard'
import InitiativeDashboard from './activities/InitiativeDashboard'
import AuditIndex from './membership/auditing/Index'
import LatestMembers from './membership/LatestMembers'

export default {
  name: 'Index',
  components: {
    SocialMediaDashboard,
    MembershipDataValidityDashboard,
    TitleBar,
    TitleBar2,
    MembershipOverviewDashboard,
    ActivitiesDashboard,
    MembershipListDashboard,
    EventDashboard,
    InitiativeDashboard,
    AuditIndex,
    LatestMembers
  },
  data () {
    console.log(this.$store.getters)
    return {
      quickLinks: [
        {
          name: 'Add Activity',
          path: 'Activity Creation',
          has_permission: true,
          icon: 'fas fa-plus pl-2'
        },
        {
          name: 'Search Organizations',
          path: 'Organization Search Tool',
          has_permission: true,
          icon: 'fas fa-search pl-2'
        },
        {
          name: 'Connect Wordpress Tags',
          path: 'WordPressTagList',
          has_permission: this.$store.getters.hasAdministrator,
          icon: 'fab fa-wordpress pl-2'
        },
        {
          name: 'Authorize LinkedIn',
          path: 'OAuth Authorization',
          has_permission: this.$store.getters.hasAdministrator,
          icon: 'fab fa-linkedin pl-2'
        },
        {
          name: 'Quickbooks Auth',
          path: 'Intuit Login',
          has_permission: this.$store.getters.hasSuperAdministrator,
          icon: 'fas fa-dollar-sign pl-2'
        }
      ],
      dashboardData: null,
      organizationData: null,
      showNewestMembers: true,
      showAllMembers: false,
      showActivites: false,
    }
  },
  methods: {
    toggleNewestMemberVisibility (e) {
      this.showNewestMembers = e
    },
    toggleAllMemberVisibility (e) {
      this.showAllMembers = e
    },
    toggleActivityVisibility (e) {
      this.showActivites = e
    },
    setDashboardData () {
      API.getDashboard().then(
        response => {
          this.dashboardData = response.data.data
        }
      )
    },
    setOrganizationData () {
      OrganizationAPI.getOrganizations_v2().then(
        response => {
          this.organizationData = response.data.data
        }
      )
    }
  },
  computed: {
    socialStatistics () {
      return this.dashboardData.social_statistics
    },
    activitiesData () {
      return this.dashboardData.activity_breakdown
    },
    memberData () {
      return this.organizationData.filter((x) => x.is_member === 1)
    },
    eventsData () {
      return this.dashboardData.events
    },
    initiativesData () {
      return this.dashboardData.initiatives
    }
  },
  mounted () {
    this.setDashboardData()
    this.setOrganizationData()
  }
}
</script>

<style scoped>
.card-body p{
  line-height: 0.25;
}
.front-page-link {
  background-color: #3E597A;
}
.front-page-link a{
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePageV2.vue